import type React from 'react'

interface OpenMapProps {
  address: string // Address input
  className?: string
}

const OpenMap: React.FC<OpenMapProps> = ({ address, className }) => {
  const encodedAddress = encodeURIComponent(address)

  // Detect Apple device (iOS, macOS)
  const isAppleDevice = /iPhone|iPad|Macintosh|iPod/.test(navigator.userAgent)

  // Generate links for Apple Maps and Google Maps
  const appleMapsLink = `https://maps.apple.com/?q=${encodedAddress}`
  const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`

  // Final link based on device
  const mapLink = isAppleDevice ? appleMapsLink : googleMapsLink

  return (
    <a
      href={mapLink}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: 'rgb(28, 100, 242)',
        textDecoration: 'none',
        display: 'inline-block',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
      }}
      className={className}
    >
      {/* <i className="fa-regular fa-location-dot mr-2 text-default" /> */}
      {address}
    </a>
  )
}

export default OpenMap
